import React from 'react';

/**
 * Marken-Logo.
 * Varianten: 'light' (dunkles Mark, für helle Flächen), 'dark' (für Navy-
 * Flächen), 'inverted' (orangenes Quadrat, navy Haus — Footer-Trust-Zeile,
 * CLAUDE.md NavyFooter). `size` steuert die Mark-Kantenlänge in px.
 */
const Logo = ({ variant = 'light', size = 36, withWordmark = true, className = '' }) => {
  const isDark = variant === 'dark';
  const isInverted = variant === 'inverted';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* Icon Mark — Spezialfall Logo (R3.1): SVG-Fills bleiben Hex */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect
          width="38"
          height="38"
          rx="10"
          fill={isInverted ? '#FF7A3D' : isDark ? '#1E293B' : '#0F172A'}
        />
        <path
          d="M19 9L9 17.5V29H15.5V22H22.5V29H29V17.5L19 9Z"
          fill={isInverted ? '#0F172A' : '#FF7A3D'}
        />
      </svg>

      {/* Wordmark */}
      {withWordmark && (
        <span className="text-[19px] lg:text-[21px] font-extrabold tracking-tight leading-none select-none">
          <span className={isDark || isInverted ? 'text-white' : 'text-ink'}>FeelAtHome</span>
          <span className="text-brand">Now</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
